import React, {Component} from 'react'
import ProxiesPage from "./ProxiesPage"
import {_getListProxies} from "../../../../../services/apis/ProxiesServices"
import {Alert} from "reactstrap";

class ProxiesPageContainer extends Component {
    state = {
        docs: [],
        total: 0,
        pagination: {
            page: 1,
            limit: 1000,
            maxPage: 1,
        },
        error: '',
        isModalOpen: false,
        modalData: {
            country: '',
            note: ''
        }
    }


    _refresh = null


    componentDidMount() {
        this._fetchProxiesList();
        this._refresh = setInterval(() => {
            this._fetchProxiesList()
        }, 5000)
    }

    componentWillUnmount() {
        this._refresh && clearInterval(this._refresh)
    }

    _fetchProxiesList = () => {
        const {page, limit} = this.state.pagination;
        _getListProxies(page, limit)
            .then(result => {
                if (result.success) {
                    this.setState(prevState => ({
                        total: result.data.total,
                        docs: result.data.docs,
                        pagination: {
                            ...prevState.pagination,
                            maxPage: result.data.pages,
                        }
                    }))
                } else {
                    this.setState({
                        error: result.message,
                    })
                }
            })
    }

    _removeProxiesFormState = (id) => {
        this.setState(({docs}) => ({
                docs: docs.filter(worker => worker._id !== id)
            })
        )
    }

    _handleChangePage = (page) => {
        const {limit} = this.state.pagination
        this.setState(prevState => ({
                pagination: {
                    ...prevState.pagination,
                    page,
                }
            })
        )
        _getListProxies(page, limit)
            .then(result => {
                if (result.success) {
                    this.setState(prevState => ({
                        total: result.data.total,
                        docs: result.data.docs,
                        pagination: {
                            ...prevState.pagination,
                            maxPage: result.data.pages,
                        }
                    }))
                } else {
                    this.setState({
                        error: result.message,
                    })
                }
            })
    }

    _handleUpdateListProxy = ({id, country, note}) => {
        this.setState(({docs}) => ({
            docs: docs.map(proxy => {
                if (proxy._id !== id) {
                    return proxy
                }
                return {
                    ...proxy,
                    country,
                    note
                }
            })
        }))
    }

    _toggleModal = () => {
        this.setState(({isModalOpen}) => ({
            isModalOpen: !isModalOpen
        }))
    }

    _closeModal = () => {
        this.setState({
            isModalOpen: false
        })
    }

    _changeModalData = (modalData) => {
        this.setState({
            modalData,
        })
    }


    render() {
        const {isModalOpen, modalData, error} = this.state

        return (
            <div>
                {error ? <Alert color="danger">{error}</Alert> :
                    <ProxiesPage {...this.state} onChangePage={this._handleChangePage}
                                 onRefreshPage={this._fetchProxiesList}
                                 removeProxyFromState={this._removeProxiesFormState}
                                 onToggleModal={this._toggleModal}
                                 onCloseModal={this._closeModal}
                                 onChangeModalData={this._changeModalData}
                                 isModalOpen={isModalOpen}
                                 modalData={modalData}
                                 onUpdateListProxy={this._handleUpdateListProxy}
                    />}
            </div>
        )
    }
}

export default ProxiesPageContainer;


// WEBPACK FOOTER //
// ./src/app/pages/dashboard/proxies/component/ProxiesPageContainer.js